// extracted by mini-css-extract-plugin
export default {"cardHeader":"cardHeader---aNe4o","layout":"layout---NKayD"};